export default "/images/1ae4b89d92a623e20d4dabbf03316ab1.avif";